import Modal from 'components/UI/Modal';
import React, { useEffect, useRef, useState, useCallback } from 'react';
import 'react-image-crop/dist/ReactCrop.css';
import styled from 'styled-components';
import { ImageCompressor } from 'image-compressor';
import { dataURLtoFile } from 'utils/utils';
import { useHttp } from 'hooks';
import Cropper from 'react-easy-crop';
import getCroppedImg from './usecanvas';
import { useTheme, useMediaQuery } from '@material-ui/core';

const StyledCropperWrapper = styled.div`
  width: 800px;
  min-height: 400px;

  ${({ mobileView, tabletView }) =>
    (mobileView || tabletView) &&
    ` width: 400px;
  `}
`;

const StyledPreview = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
`;

const StyledImage = styled.img`
  background-color: #f5f5f5;
  width: 100%;
  max-height: 500px;
  object-fit: contain;
  border: solid 1px #dadada;
`;

function EasyCropper(props) {
  const CROP_AREA_ASPECT = 205 / 78;
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down('sm'));
  const tabletView = useMediaQuery(theme.breakpoints.down('md'));
  const { imageToCrop, isOpen, onClose, field, setFieldValue, shape, title, submitTitle } = props;
  const { request } = useHttp();
  const [uploading, setUploading] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);

  const Submit = () => {
    setUploading(true);
    const formData = new FormData();
    getCroppedImg(imageToCrop, croppedAreaPixels, rotation, true).then(data => {
      if (field && data) {
        formData.append('file', dataURLtoFile(data));
        request('/content/addpublicimage', 'POST', formData, {
          'Content-Type': 'multipart/form-data',
        })
          .then(image => {
            setFieldValue(field, image);
          })
          .catch(console.dir)
          .finally(() => {
            onClose();
            setUploading(false);
          });
      }
    });
  };
  useEffect(() => {
    getCroppedImg(imageToCrop, croppedAreaPixels, rotation).then(croppedImage => {
      setCroppedImage(croppedImage);
    });
  }, [croppedAreaPixels]);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  return (
    <Modal
      isCreatingContribution
      brandingColor={false}
      title={title}
      isOpen={isOpen}
      hiddenCancel
      loading={uploading}
      onCancel={() => {
        onClose();
      }}
      dontCancelOnSideClick
      onSubmit={() => {
        Submit();
      }}
      submitTitle={submitTitle}
    >
      <StyledCropperWrapper tabletView={tabletView} mobileView={mobileView}>
        <div
          style={{
            position: 'relative',
            height: '208px',
            width: '750px',
            alignSelf: 'center',
            color: 'black',
          }}
        >
          {!!imageToCrop && (
            <Cropper
              style={{ width: '560px' }}
              image={imageToCrop}
              aspect={CROP_AREA_ASPECT}
              // cropSize={{
              //   width:850,height:312
              // }}
              crop={crop}
              zoom={zoom}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
            />
          )}
        </div>
        <StyledPreview>
          <div style={{ fontWeight: 'bold' }}>Preview</div>
          <div
            style={{
              height: '220px',
              display: 'flex',
              // alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
              marginTop: '30px',
            }}
          >
            {croppedImage && (
              <img
                style={{
                  marginLeft: mobileView ? '200px' : '' || tabletView ? '200px' : '',
                  height: '200px',
                  position: 'absolute',
                }}
                src={croppedImage}
                alt="cropped"
              />
            )}
          </div>
        </StyledPreview>
      </StyledCropperWrapper>
    </Modal>
  );
}

export default EasyCropper;
